import React from 'react';

import useUI from 'hooks/use-ui';

import { DutchiePayCtaModal } from './dutchie-pay/cta';
import { ModalNames } from './modals.types';

import { AddressRequired } from './address-required';
import { EmptyCart } from './empty-cart';
import { Login } from './login';
import { ResetPassword } from './reset-password';
import { SignUp } from './sign-up';
import { ChangePassword } from './change-password';
import { ClearYourCart } from './clear-your-cart';
import { OrderType } from './order-type';
import { DeliveryAddress } from './delivery-address';
import { OrderReceipt } from './order-receipt';
import { ShoppingWith } from './shopping-with';
import { AddToCart } from './add-to-cart';
import { BuyingOptions } from './buying-options';
import { OrderStatus } from './order-status-modal';
import { MarketplaceBrandsFilterDrawer, DispensaryBrandsFilterDrawer } from './brands-filter-drawer';
import { MarketplaceStrainTypeFilterDrawer, DispensaryStrainTypeFilterDrawer } from './strain-type-filter-drawer';
import { SelectStore } from './select-store';
import { DistanceFilterBottomDrawer as ConsumerDistanceFilter } from './distance-filter-bottom-drawer/consumer';
import { DistanceFilterBottomDrawer as MarketplaceDistanceFilter } from './distance-filter-bottom-drawer/marketplace';
import { ClosedBut } from './closed-but';
import { StoreSwitched } from './store-switched';

export const Modals = (): JSX.Element | null => {
  const UI = useUI();

  if (UI.isDemo) {
    return null;
  }

  return (
    <>
      <AddressRequired name={ModalNames.addressRequired} />
      <BuyingOptions name={ModalNames.buyingOptions} />
      <ChangePassword name={ModalNames.changePassword} />
      <ConsumerDistanceFilter name={ModalNames.consumerDistanceFilter} />
      <DeliveryAddress name={ModalNames.deliveryAddress} />
      <EmptyCart name={ModalNames.emptyCart} />
      <Login name={ModalNames.login} />
      <MarketplaceDistanceFilter name={ModalNames.marketplaceDistanceFilter} />
      <OrderReceipt name={ModalNames.orderReceipt} />
      <OrderStatus name={ModalNames.orderStatus} />
      <OrderType name={ModalNames.orderType} />
      <ResetPassword name={ModalNames.resetPassword} />
      <SelectStore name={ModalNames.selectStore} />
      <SignUp name={ModalNames.signUp} />
      <DutchiePayCtaModal name={ModalNames.dutchiePayCta} />
      {/* withModalConrolsHook modals */}
      <ClearYourCart />
      <DispensaryBrandsFilterDrawer />
      <DispensaryStrainTypeFilterDrawer />
      <MarketplaceBrandsFilterDrawer />
      <MarketplaceStrainTypeFilterDrawer />
      <ShoppingWith />
      <AddToCart />
      <ClosedBut />
      <StoreSwitched />
    </>
  );
};
